/**
 * Notification labels
 * Dynamic mapping from JSON based on current language
 * Uses getLanguage() to determine which locale to use
 */

import svNotifications from '../locales/sv/notifications.json';
import enNotifications from '../locales/en/notifications.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

/**
 * Helper function to get the correct locale based on language
 */
const getNotificationLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enNotifications : svNotifications;
};

/**
 * Notification labels - dynamically uses current language
 */
export const notificationLabels = (lang?: Language): Record<string, any> => {
  const locale = getNotificationLocale(lang);
  return locale;
};

